module.exports = __webpack_public_path__ + "img/bilibili.8a3abb18.png";